const navbar = {
  packages: "แพ็คเกจ", // translated
  hotelPackages: "แพ็คเกจโรงแรม", // translated
  experiences: "ประสบการณ์", // translated
  close: "ปิด", // translated
  hotDeals: "ข้อเสนอสุดพิเศษ", // translated
  dashboard: "แผงควบคุม", // translated
  pricing: "ราคา", // translated
};


export default navbar;
